import { observer } from 'mobx-react-lite';
import { useTypedParams } from 'react-router-typesafe-routes/dom';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';
import {
  NotificationsProvider,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { appRoute } from 'app/railways/router/routes';
import { PageContent } from 'app/ui';

import { UpdateRoleFeature } from '../features/roles/update-role';

export const UpdateRolePage = observer(() => {
  const pageNotify = useNotifyFactory();
  const { roleId } = useTypedParams(appRoute.ROLES.DETAILS);

  if (!roleId)
    return (
      <AppPage perm="PERM_USER_ROLE_READ">
        <PageContent>Не задан ID роли в URL</PageContent>
      </AppPage>
    );

  return (
    <NotificationsProvider value={pageNotify}>
      <AppPage perm="PERM_USER_ROLE_READ">
        <PageContent>
          <UpdateRoleFeature roleId={roleId} />
        </PageContent>
      </AppPage>
    </NotificationsProvider>
  );
});
